import React from "react";
import { LucideIcon } from "lucide-react";

type CourierCardProps = {
  staffCount: any;
  companyName: string;
  icon: LucideIcon;
};

const CourierCard: React.FC<CourierCardProps> = ({
  staffCount,
  companyName,
  icon: Icon,
}) => {
  return (
    <div className="bg-white p-4 rounded-lg border border-borderColor flex items-center justify-between">
      <div>
        <h3 className="text-sm text-gray-500">{staffCount}</h3>
        <p className="text-sm sm:text-md md:text-lg font-bold mt-1">
          {companyName}
        </p>
      </div>
      <Icon className="h-4 w-4 sm:h-8 sm:w-8 text-gray-400" />
    </div>
  );
};

export default CourierCard;
